/**
 * Shared date/time helpers for tour scheduler adapters and UI.
 */

export function isoToApiDate(iso: string): string {
  const [year, month, day] = iso.split('-');
  return `${month}/${day}/${year}`;
}

export function timeToMinutes(t: string): number {
  const [time, period] = t.split(' ');
  let [h, m] = time.split(':').map(Number);
  if (period === 'PM' && h < 12) h += 12;
  if (period === 'AM' && h === 12) h = 0;
  return h * 60 + m;
}

export function sortTimeSlots(times: string[]): string[] {
  return [...times].sort((a, b) => timeToMinutes(a) - timeToMinutes(b));
}

/**
 * Convert a property-local `YYYY-MM-DDTHH:mm:ss` instant from GET /tour-times
 * into a display string like "9:30 AM". Returns '' when the time can't be read.
 */
export function isoDateTimeToDisplayTime(isoDateTime: string): string {
  const match = String(isoDateTime).match(/T(\d{2}):(\d{2})/);
  if (!match) return '';
  let hour = parseInt(match[1], 10);
  const minute = match[2];
  const period = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${period}`;
}
